import { useState } from "react";
import { Button, Col, Form, Row, Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { useMutation } from "@tanstack/react-query";

const AddTranscriptModal = ({ onClose,onSave, videoCode, enableChapterRegeneration }) => {
    // const [startTime, setStartTime] = useState("");
    // const [endTime, setEndTime] = useState("");
    // const [transcript, setTranscript] = useState("");
    // const [saving, setSaving] = useState(false);

    const [form, setForm] = useState({
        startTime: "",
        endTime: "",
        transcript: ""
    });



    const addTranscript = async ({ start, end, text }) => {
        await axios.post(`${process.env.REACT_APP_API_URL}/video_guide/transcripts`, {
            VideoID: videoCode,
            data: {
                start: +start,
                end: +end,
                text: text,
            },
        });
    };


    const { mutate: addTranscriptMutation, isPending: isAddingTranscript } = useMutation({
        mutationFn: addTranscript,
        onSuccess: () => {
            enableChapterRegeneration(true);
            toast.success("Successfully saved the transcript.");
            onSave();
            onClose();
        },
        onError: (err) => {
            toast.error("Error saving the transcript.");
        },
    });

    // const handleSave = useCallback(() => {
    //     setSaving(true);
    //     axios.post(`${process.env.REACT_APP_API_URL}/video_guide/transcripts`, {
    //         VideoID: videoCode,
    //         data: {
    //             start: +startTime,
    //             end: +endTime,
    //             text: transcript,
    //         },
    //     })
    //         .then(() => {
    //             enableChapterRegeneration(true);
    //             toast.success("Successfully saved the transcript.");
    //             onSave();
    //             onClose();
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //             toast.error("Error saving the transcript.");
    //         })
    //         .finally(() => {
    //             setSaving(false);
    //         });
    // }, [videoCode, startTime, endTime, transcript, enableChapterRegeneration, onClose]);

    return (
        <Modal show onHide={onClose} centered size="xl" style={{ zIndex: 10000 }}>
            <Modal.Header closeButton>
                <Modal.Title>New Transcript</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="my-3">
                    <Col xs="6">
                        <Form.Group className="mb-2">
                            <Form.Label>Start Time</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="00.00"
                                value={form.startTime}
                                onChange={(e) =>
                                    setForm(prev => ({ ...prev, startTime: e.target.value }))
                                }
                                // onChange={(e) => setStartTime(e.target.value)}
                                disabled={isAddingTranscript}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs="6">
                        <Form.Group className="mb-2">
                            <Form.Label>End Time</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="00.00"
                                value={form.endTime}
                                onChange={(e) => setForm(prev => ({ ...prev, endTime: e.target.value }))}
                                disabled={isAddingTranscript}
                            />
                        </Form.Group>
                    </Col>
                    <Form.Group className="mb-2">
                        <Form.Label>Transcript</Form.Label>
                        <Form.Control
                            as="textarea"
                            value={form.transcript}
                            onChange={(e) => setForm(prev => ({ ...prev, transcript: e.target.value }))}
                            disabled={isAddingTranscript}
                            style={{ minHeight: 80 }}
                        />
                    </Form.Group>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'end' }}>
                        <Button
                            variant="primary"
                            onClick={() => addTranscriptMutation({start: +form.startTime, end: +form.endTime, text: form.transcript})}
                            disabled={isAddingTranscript || !form.startTime || !form.endTime || !form.transcript.trim()}
                        >
                            {isAddingTranscript ? "Saving..." : "Save Transcript"}
                        </Button>
                    </div>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default AddTranscriptModal;